import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetFundraisingCampaignResponse,
  GetFundraisingCampaignByIdResponse,
  GetFundraisingCampaignJustifyExpensesResponse,
} from '../response/fundraising-campaign';
import {
  CreateFundraisingCampaignPayload,
  UpdateFundraisingCampaignPayload,
  CreateFundraisingCampaignJustifyExpensesPayload,
  UpdateFundraisingCampaignJustifyExpensesPayload,
} from '../request/fundraising-campaign';

export class FundraisingCampaignService {
  static getFundraisingCampaign(params?: QueryParams) {
    return apiClient.get<GetFundraisingCampaignResponse>(buildApiUrl('/api/v1/fundraising-campaign'), params);
  }

  static postFundraisingCampaign(data: CreateFundraisingCampaignPayload) {
    return apiClient.createWithFile<void>(buildApiUrl('/api/v1/fundraising-campaign'), data);
  }

  static putFundraisingCampaign(id: string, data: UpdateFundraisingCampaignPayload) {
    const url = buildApiUrl('/api/v1/fundraising-campaign/:id', { id });
    return apiClient.updateWithFile<void>(url, data);
  }

  static getFundraisingCampaignById(id: string) {
    const url = buildApiUrl('/api/v1/fundraising-campaign/:id', { id });
    return apiClient.get<GetFundraisingCampaignByIdResponse>(url);
  }

  static publishFundraisingCampaign(id: string) {
    const url = buildApiUrl('/api/v1/fundraising-campaign/:id/publish', { id });
    return apiClient.update<void>(url);
  }

  static endFundraisingCampaign(id: string) {
    const url = buildApiUrl('/api/v1/fundraising-campaign/:id/end', { id });
    return apiClient.update<void>(url);
  }

  static deleteFundraisingCampaign(id: string) {
    const url = buildApiUrl('/api/v1/fundraising-campaign/:id', { id });
    return apiClient.delete<void>(url);
  }

  static getFundraisingCampaignJustifyExpenses(id: string) {
    return apiClient.get<GetFundraisingCampaignJustifyExpensesResponse>(
      buildApiUrl('/api/v1/fundraising-campaign/:id/justify-expenses', { id }),
    );
  }

  static postFundraisingCampaignJustifyExpenses(id: string, payload: CreateFundraisingCampaignJustifyExpensesPayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/fundraising-campaign/:id/justify-expenses', { id }), payload);
  }

  static putFundraisingCampaignJustifyExpenses(id: string, payload: UpdateFundraisingCampaignJustifyExpensesPayload) {
    return apiClient.post<void>(buildApiUrl('/api/v1/fundraising-campaign/:id/justify-expenses', { id }), payload);
  }
}
